<template>
   <div class="wlmq_mediaNew_container">
        <div class="head">
      <div class="head_title">
        <img src="../../../assets/Uram/HongNetwork/articleLogo_02.png" />
       <p> 全市各单位最新发布</p>
      </div>
      <div class="head_logo">  
      {{nowDate}}&nbsp;&nbsp;<span style="color:rgba(22, 126, 255, 1)">{{nowWeek}}</span>       
      </div>
    </div>
    <div class="main">
     <div class="main_li" v-for="(item,index) in list.slice(left,right)" 
      :key="item.index"
       :class="item.index == activeIndex ? 'active' : ''"
      >
      <div class="li_os" >
        <div class="imgs_t"></div>
       <div :id="time(index)"  class="bottom"></div>
      </div> 
     <div class="li_img">
        <img :src="item.avatar" alt="">
     </div>
     <div class="li_time"  @click="showDialog(item)">
       <div class="time_title">{{item.title}}</div>
       <div class="time_over"> 
        <div class="time_yuan">{{item.source_name}}</div>
        <div class="time_date">{{item.news_time}}</div>
       </div>
     </div>  
       </div>
    </div>
    <el-dialog
  :visible.sync="dialogVisible"
  width="30%"
  :before-close="handleClose">
   <div class="body_tiele">{{this.obj.title}} <img class="body_img" @click="goindr(obj.url)" src="@/assets/lian.png" alt=""> </div>
    <div class="live">{{this.obj.source_name}}<div>{{this.obj.news_time}}</div></div>
    <div  class="body_cont">{{this.obj.content}}
    <div class="time_img">
     <div class="wx_img" v-for="(item,index) in hoot" :key="index">
          <img  class="img_wx" :src="item.imgs" alt="">
     </div>
     </div>


    </div>
  <span slot="footer" class="dialog-footer">
    
  </span>
</el-dialog>
       
 </div>
</template>

<script>
import {Qubot} from '@/api/UramWu/uram'
export default {
    name:'newsGod',
    data(){
        return{
        hoot:[],
       list:[],
        dialogVisible: false,  
        obj:{},
      left:0,
      right:6,
      activeIndex: "0", 
      nowDate:'', 
      nowWeek:'', 
        } 
    },
    created(){
  
    },
    mounted(){
    this.load();
    this.moon();//当前时间和当前日期
    },
    methods:{
  
      load(){
     Qubot().then(res=>{
    this.list=res.data.data
     const self = this;

    this.interval = setInterval(function() {
      if(self.activeIndex<5) {
        self.activeIndex++;
    //  console.log(self.activeIndex,'我是太阳')
      } else if((self.activeIndex>=5)&&(self.activeIndex<11)){
         self.activeIndex++;
        self.left=6;
        self.right=12;
        // console.log(self.activeIndex,'我睡觉')
        if(self.list.length==self.activeIndex){
          self.left=0;
          self.right=6;
          self.activeIndex=0
        }

      }else if((self.activeIndex>=11)&&(self.activeIndex<=16)){
         self.activeIndex++;
        self.left=12;
        self.right=18; 
        // console.log(self.activeIndex,'第三步')

      if(self.list.length==self.activeIndex){
          self.left=0;
          self.right=6;
          self.activeIndex=0
        }
      }else if((self.activeIndex>=16)&&(self.activeIndex<=20)){
        self.left=0;
        self.right=6; 
        self.activeIndex=0
        // console.log(self.activeIndex,'清空')
      }
    }, 5000);
     })
     
      },
   moon(){
let myDate = new Date()
  // console.log(myDate)
  let wk = myDate.getDay()
  let yy = String(myDate.getFullYear())
  let mm = myDate.getMonth() + 1
  let dd = String(myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate())
  let hou = String(myDate.getHours() < 10 ? '0' + myDate.getHours() : myDate.getHours())
  let min = String(myDate.getMinutes() < 10 ? '0' + myDate.getMinutes() : myDate.getMinutes())
  let sec = String(myDate.getSeconds() < 10 ? '0' + myDate.getSeconds() : myDate.getSeconds())
  let weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
  let week = weeks[wk]
  this.nowDate = yy +'年' + mm + '月' + dd +'日'
  this.nowTime = hou + ':' + min + ':' + sec
  this.nowWeek = week

   },
     time(index) {
      return "person_" +index
     },
     showDialog(item){
       this.dialogVisible=true
       this.obj=item;
      const over=[]
      over.push(this.obj.imgs.split(','))
    const serve=[]
     over[0].forEach(item=>{
      serve.push(
    {"imgs":item}
      )
     })
     this.hoot=serve
     },
       handleClose(done) {
       this.dialogVisible=false;
       this.hoot=[]
      },
         goindr(url) {
      window.open(url);
    },
    },
    
}
</script>

<style lang="scss" scoped>
.time_img{
  width: 100%;
  height: 5vh;
  display: flex;
// justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.wx_img{
padding: 10px;
.img_wx{
  width:170px;
  height: 140px;
}
}
    //激活状态
        .active {
          .li_time{
   width: 78vw !important;
   height: 23vh   !important;
   position: absolute !important;
   background: url("../../../assets/Uram/HongNetwork/ju.png") no-repeat !important;
     background-size: 100% 100% !important;
    margin-left: -3vw;
    padding-left: 4% !important;
    padding-top: 5.3vh !important
          }
          .time_title {
           color: rgba(246, 194, 14, 1) !important;
          }
          .time_date{
            position: relative;
            left:-82px;
          }
          .imgs_t{
  width: 40px;
   height: 40px;
   position: relative;
   left: 32px;
   background: url('../../../assets/Uram/HongNetwork/hong.png') no-repeat !important;
   background-size: 100% 100% !important;
          }
          

        }
.body_tiele{
  font-size: 30px;
font-family: PingFang;
font-weight: bold;
color: #FFFFFF;
line-height: 36px;
text-align: center;
}
.body_img{
  position: relative;
  left: 5px;
  cursor: pointer;
}
.live{
  width: 50%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 60px;
  margin: 0 auto;
  font-size: 18px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #60D6DD;
}
.body_cont{
  width: 90%;
  height: 57vh;
  overflow-y: scroll;
  margin: 0 auto;
  font-size: 22px;
font-family: Microsoft YaHei;
font-weight: 400;
line-height: 28px;
color: #FFFFFF;
}
.wlmq_mediaNew_container {
  width: 100%;
  height: 100%;
  background-image: url("../../../assets/Uram/HongNetwork/bei.png");
  background-size: 100% 100%;
    .head {
    width: 100%;
    height: 9.5vh;
    display: flex;
    color: #fff;
    .head_title {
      font-weight: bold;
      font-size: 2vw;
      line-height: 3;
      width: 23%;
      margin-left: 4.3%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      p{
          margin-top: 10px;
      }
      img {
        vertical-align: middle;
       width: 48px;
       height: 48px;
        margin-right: 1.2%;
        margin-top: 10px;
      }
    }
    .head_logo {
      width: 10.67%;
      height: 4.44vh;
      position: absolute;
      top: 4vh;
      right: 4%;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.main{
    width: 90%;
    height: 82vh;
    margin: 2.5vh auto;
}
.main_li{
  width: 100%;
  height: 13vh;
  display: flex;
  justify-content: space-around;
    align-items: center;
    position: relative;
    cursor: pointer;
    margin-top: 1.1vh;
//  .li_time:hover{
//   width: 78vw;
//    height: 170px;
//    position: absolute;
//    background: url("../../../assets/Uram/HongNetwork/ju.png") no-repeat;
//   background-size: 100% 100%;
// .time_title{
//   width: 80%;
//   height: 55px;
// font-size: 36px;
// font-family: PingFang SC;
// font-weight: bold;
// color: rgba(246, 194, 14, 1);
//   overflow: hidden;
//  text-overflow:ellipsis;
//   white-space: nowrap;
// position: relative;
// padding: 20px;
// top: 40px;
// left: 5%;
// }
// .time_date{
//   width: 176px;
// height: 13px;
// font-size: 16px;
// font-family: PingFang SC;
// font-weight: bold;
// color: #FFFFFF;
// width: 176px;
// height: 13px;
// font-size: 16px;
// font-family: PingFang SC;
// font-weight: bold;
// color: #FFFFFF;
// position: relative;
// top: 30px;
// left: -5%;

// }
// .time_yuan{
//   width: 224px;
// height: 20px;
// font-size: 20px;
// font-family: PingFang SC;
// font-weight: bold;
// color: #FFFFFF;
// position: relative;
// top: 30px;
// left: 5%;
//   overflow: hidden;
//  text-overflow:ellipsis;
//   white-space: nowrap;
// }
// }  

.li_os{
  width: 100px;
  height: 100px;
  position: absolute;
  left: 3%;
  top: 3.5vh;
  .imgs_t{
       width: 40px;
   height: 40px;
   position: relative;
   left: 32px;
   background: url('../../../assets/Uram/HongNetwork/yuan.png') no-repeat;
   background-size: 100% 100%;
  }

  .bottom{
    width: 1px;
    height: 11vh;
    border: 1px dashed  #0BF6FF ;
    position: relative;
    left: 50px;
    margin-top: -14px;
  }
  #person_5{
    display: none;
  }
}
.li_img{
  position: absolute;
  left: 9%;
  img{
    width: 61px;
    height: 61px;
    border-radius: 50px;
  }
  
}
.li_time{
  width: 73vw;
 height: 12vh;
   position: absolute;
   left: 15%;
   background: url("../../../assets/Uram/HongNetwork/ju1.png") no-repeat;
  background-size: 100% 100%;
.time_title{
  width: 80%;
  height: 45px;
font-size: 36px;
font-family: PingFang SC;
font-weight: bold;
color: #FFFFFF;
  overflow: hidden;
 text-overflow:ellipsis;
  white-space: nowrap;
  padding: 15px;


}
.time_over{
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 5px;
}
.time_yuan{
  width: 224px;
height: 20px;
font-size: 20px;
font-family: PingFang SC;
font-weight: bold;
color: #FFFFFF;
padding-left: 20px;
  overflow: hidden;
 text-overflow:ellipsis;
  white-space: nowrap;
}
.time_date{
  width: 176px;
height: 13px;
font-size: 16px;
font-family: PingFang SC;
font-weight: bold;
color: #FFFFFF;
width: 176px;
height: 13px;
font-size: 16px;
font-family: PingFang SC;
font-weight: bold;
color: #FFFFFF;
}
} 
}
</style>